import React, { ReactElement } from 'react'
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { IRouteItem } from '../../../../routes/interfaces/IRouteItem';
import styles from './child-menu-item.module.scss';
import { getRootUrl } from '../../../../misc';
import { FormattedMessage } from 'react-intl';

interface ChildMenuItemProps {
    route: IRouteItem,
    open?: boolean;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const ChildMenuItem: React.FC<ChildMenuItemProps> = (props): ReactElement => {
    const { route, open, onClick } = props;

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
        if (onClick) {
            onClick(event);
        }
    };

    return (<Link
        key={route.name}
        to={route.url ? route.url : '#'}
        className={classNames({
            [styles.childMenuItem]: true,
            [styles.active]: route.url ? route.url === getRootUrl(location.pathname) : false
        })}
        onClick={handleClick}>
        { route.name && (open === undefined || open) ? (
            <span className={styles.text}>
                <FormattedMessage id={route.name} />
            </span>
        ) : <></>}
    </Link>)
}
